// Forked from https://github.com/microsoft/fluentui/blob/master/packages/react-theme/src/types.ts:ColorTokens
// The tokens are designed to match with https://github.com/microsoft/fluentui/blob/master/packages/react-theme/src/tokens.ts:tokens
export const FluentV9ColorTokens = {
  colorNeutralForeground1: '--colorNeutralForeground1' as const,
  colorNeutralForeground1Hover: '--colorNeutralForeground1Hover' as const,
  colorNeutralForeground1Pressed: '--colorNeutralForeground1Pressed' as const,
  colorNeutralForeground1Selected: '--colorNeutralForeground1Selected' as const,
  colorNeutralForeground2: '--colorNeutralForeground2' as const,
  colorNeutralForeground2Hover: '--colorNeutralForeground2Hover' as const,
  colorNeutralForeground2Pressed: '--colorNeutralForeground2Pressed' as const,
  colorNeutralForeground2Selected: '--colorNeutralForeground2Selected' as const,
  colorNeutralForeground2BrandHover: '--colorNeutralForeground2BrandHover' as const,
  colorNeutralForeground2BrandPressed: '--colorNeutralForeground2BrandPressed' as const,
  colorNeutralForeground2BrandSelected: '--colorNeutralForeground2BrandSelected' as const,
  colorNeutralForeground3: '--colorNeutralForeground3' as const,
  colorNeutralForeground3Hover: '--colorNeutralForeground3Hover' as const,
  colorNeutralForeground3Pressed: '--colorNeutralForeground3Pressed' as const,
  colorNeutralForeground3Selected: '--colorNeutralForeground3Selected' as const,
  colorNeutralForeground3BrandHover: '--colorNeutralForeground3BrandHover' as const,
  colorNeutralForeground3BrandPressed: '--colorNeutralForeground3BrandPressed' as const,
  colorNeutralForeground3BrandSelected: '--colorNeutralForeground3BrandSelected' as const,
  colorNeutralForeground4: '--colorNeutralForeground4' as const,
  colorNeutralForegroundDisabled: '--colorNeutralForegroundDisabled' as const,
  colorNeutralForegroundInvertedDisabled: '--colorNeutralForegroundInvertedDisabled' as const,
  colorBrandForegroundLink: '--colorBrandForegroundLink' as const,
  colorBrandForegroundLinkHover: '--colorBrandForegroundLinkHover' as const,
  colorBrandForegroundLinkPressed: '--colorBrandForegroundLinkPressed' as const,
  colorBrandForegroundLinkSelected: '--colorBrandForegroundLinkSelected' as const,
  colorCompoundBrandForeground1: '--colorCompoundBrandForeground1' as const,
  colorCompoundBrandForeground1Hover: '--colorCompoundBrandForeground1Hover' as const,
  colorCompoundBrandForeground1Pressed: '--colorCompoundBrandForeground1Pressed' as const,
  colorBrandForeground1: '--colorBrandForeground1' as const,
  colorBrandForeground2: '--colorBrandForeground2' as const,
  colorNeutralForeground1Static: '--colorNeutralForeground1Static' as const,
  colorNeutralForegroundInverted: '--colorNeutralForegroundInverted' as const,
  colorNeutralForegroundInvertedHover: '--colorNeutralForegroundInvertedHover' as const,
  colorNeutralForegroundInvertedPressed: '--colorNeutralForegroundInvertedPressed' as const,
  colorNeutralForegroundInvertedSelected: '--colorNeutralForegroundInvertedSelected' as const,
  colorNeutralForegroundOnBrand: '--colorNeutralForegroundOnBrand' as const,
  colorNeutralForegroundInvertedLink: '--colorNeutralForegroundInvertedLink' as const,
  colorNeutralForegroundInvertedLinkHover: '--colorNeutralForegroundInvertedLinkHover' as const,
  colorNeutralForegroundInvertedLinkPressed: '--colorNeutralForegroundInvertedLinkPressed' as const,
  colorNeutralForegroundInvertedLinkSelected: '--colorNeutralForegroundInvertedLinkSelected' as const,
  colorBrandForegroundInverted: '--colorBrandForegroundInverted' as const,
  colorBrandForegroundInvertedHover: '--colorBrandForegroundInvertedHover' as const,
  colorBrandForegroundInvertedPressed: '--colorBrandForegroundInvertedPressed' as const,
  colorBrandForegroundOnLight: '--colorBrandForegroundOnLight' as const,
  colorBrandForegroundOnLightHover: '--colorBrandForegroundOnLightHover' as const,
  colorBrandForegroundOnLightPressed: '--colorBrandForegroundOnLightPressed' as const,
  colorBrandForegroundOnLightSelected: '--colorBrandForegroundOnLightSelected' as const,
  colorNeutralBackground1: '--colorNeutralBackground1' as const,
  colorNeutralBackground1Hover: '--colorNeutralBackground1Hover' as const,
  colorNeutralBackground1Pressed: '--colorNeutralBackground1Pressed' as const,
  colorNeutralBackground1Selected: '--colorNeutralBackground1Selected' as const,
  colorNeutralBackground2: '--colorNeutralBackground2' as const,
  colorNeutralBackground2Hover: '--colorNeutralBackground2Hover' as const,
  colorNeutralBackground2Pressed: '--colorNeutralBackground2Pressed' as const,
  colorNeutralBackground2Selected: '--colorNeutralBackground2Selected' as const,
  colorNeutralBackground3: '--colorNeutralBackground3' as const,
  colorNeutralBackground3Hover: '--colorNeutralBackground3Hover' as const,
  colorNeutralBackground3Pressed: '--colorNeutralBackground3Pressed' as const,
  colorNeutralBackground3Selected: '--colorNeutralBackground3Selected' as const,
  colorNeutralBackground4: '--colorNeutralBackground4' as const,
  colorNeutralBackground4Hover: '--colorNeutralBackground4Hover' as const,
  colorNeutralBackground4Pressed: '--colorNeutralBackground4Pressed' as const,
  colorNeutralBackground4Selected: '--colorNeutralBackground4Selected' as const,
  colorNeutralBackground5: '--colorNeutralBackground5' as const,
  colorNeutralBackground5Hover: '--colorNeutralBackground5Hover' as const,
  colorNeutralBackground5Pressed: '--colorNeutralBackground5Pressed' as const,
  colorNeutralBackground5Selected: '--colorNeutralBackground5Selected' as const,
  colorNeutralBackground6: '--colorNeutralBackground6' as const,
  colorNeutralBackgroundInverted: '--colorNeutralBackgroundInverted' as const,
  colorSubtleBackground: '--colorSubtleBackground' as const,
  colorSubtleBackgroundHover: '--colorSubtleBackgroundHover' as const,
  colorSubtleBackgroundPressed: '--colorSubtleBackgroundPressed' as const,
  colorSubtleBackgroundSelected: '--colorSubtleBackgroundSelected' as const,
  colorSubtleBackgroundLightAlphaHover: '--colorSubtleBackgroundLightAlphaHover' as const,
  colorSubtleBackgroundLightAlphaPressed: '--colorSubtleBackgroundLightAlphaPressed' as const,
  colorSubtleBackgroundLightAlphaSelected: '--colorSubtleBackgroundLightAlphaSelected' as const,
  colorSubtleBackgroundInverted: '--colorSubtleBackgroundInverted' as const,
  colorSubtleBackgroundInvertedHover: '--colorSubtleBackgroundInvertedHover' as const,
  colorSubtleBackgroundInvertedPressed: '--colorSubtleBackgroundInvertedPressed' as const,
  colorSubtleBackgroundInvertedSelected: '--colorSubtleBackgroundInvertedSelected' as const,
  colorTransparentBackground: '--colorTransparentBackground' as const,
  colorTransparentBackgroundHover: '--colorTransparentBackgroundHover' as const,
  colorTransparentBackgroundPressed: '--colorTransparentBackgroundPressed' as const,
  colorTransparentBackgroundSelected: '--colorTransparentBackgroundSelected' as const,
  colorNeutralBackgroundDisabled: '--colorNeutralBackgroundDisabled' as const,
  colorNeutralBackgroundInvertedDisabled: '--colorNeutralBackgroundInvertedDisabled' as const,
  colorNeutralStencil1: '--colorNeutralStencil1' as const,
  colorNeutralStencil2: '--colorNeutralStencil2' as const,
  colorBrandBackground: '--colorBrandBackground' as const,
  colorBrandBackgroundHover: '--colorBrandBackgroundHover' as const,
  colorBrandBackgroundPressed: '--colorBrandBackgroundPressed' as const,
  colorBrandBackgroundSelected: '--colorBrandBackgroundSelected' as const,
  colorCompoundBrandBackground: '--colorCompoundBrandBackground' as const,
  colorCompoundBrandBackgroundHover: '--colorCompoundBrandBackgroundHover' as const,
  colorCompoundBrandBackgroundPressed: '--colorCompoundBrandBackgroundPressed' as const,
  colorBrandBackgroundStatic: '--colorBrandBackgroundStatic' as const,
  colorBrandBackground2: '--colorBrandBackground2' as const,
  colorBrandBackgroundInverted: '--colorBrandBackgroundInverted' as const,
  colorBrandBackgroundInvertedHover: '--colorBrandBackgroundInvertedHover' as const,
  colorBrandBackgroundInvertedPressed: '--colorBrandBackgroundInvertedPressed' as const,
  colorBrandBackgroundInvertedSelected: '--colorBrandBackgroundInvertedSelected' as const,
  colorNeutralStrokeAccessible: '--colorNeutralStrokeAccessible' as const,
  colorNeutralStrokeAccessibleHover: '--colorNeutralStrokeAccessibleHover' as const,
  colorNeutralStrokeAccessiblePressed: '--colorNeutralStrokeAccessiblePressed' as const,
  colorNeutralStrokeAccessibleSelected: '--colorNeutralStrokeAccessibleSelected' as const,
  colorNeutralStroke1: '--colorNeutralStroke1' as const,
  colorNeutralStroke1Hover: '--colorNeutralStroke1Hover' as const,
  colorNeutralStroke1Pressed: '--colorNeutralStroke1Pressed' as const,
  colorNeutralStroke1Selected: '--colorNeutralStroke1Selected' as const,
  colorNeutralStroke2: '--colorNeutralStroke2' as const,
  colorNeutralStroke3: '--colorNeutralStroke3' as const,
  colorNeutralStrokeOnBrand: '--colorNeutralStrokeOnBrand' as const,
  colorNeutralStrokeOnBrand2: '--colorNeutralStrokeOnBrand2' as const,
  colorNeutralStrokeOnBrand2Hover: '--colorNeutralStrokeOnBrand2Hover' as const,
  colorNeutralStrokeOnBrand2Pressed: '--colorNeutralStrokeOnBrand2Pressed' as const,
  colorNeutralStrokeOnBrand2Selected: '--colorNeutralStrokeOnBrand2Selected' as const,
  colorBrandStroke1: '--colorBrandStroke1' as const,
  colorBrandStroke2: '--colorBrandStroke2' as const,
  colorCompoundBrandStroke: '--colorCompoundBrandStroke' as const,
  colorCompoundBrandStrokeHover: '--colorCompoundBrandStrokeHover' as const,
  colorCompoundBrandStrokePressed: '--colorCompoundBrandStrokePressed' as const,
  colorNeutralStrokeDisabled: '--colorNeutralStrokeDisabled' as const,
  colorNeutralStrokeInvertedDisabled: '--colorNeutralStrokeInvertedDisabled' as const,
  colorTransparentStroke: '--colorTransparentStroke' as const,
  colorTransparentStrokeInteractive: '--colorTransparentStrokeInteractive' as const,
  colorTransparentStrokeDisabled: '--colorTransparentStrokeDisabled' as const,
  colorStrokeFocus1: '--colorStrokeFocus1' as const,
  colorStrokeFocus2: '--colorStrokeFocus2' as const,
  colorNeutralShadowAmbient: '--colorNeutralShadowAmbient' as const,
  colorNeutralShadowKey: '--colorNeutralShadowKey' as const,
  colorNeutralShadowAmbientLighter: '--colorNeutralShadowAmbientLighter' as const,
  colorNeutralShadowKeyLighter: '--colorNeutralShadowKeyLighter' as const,
  colorNeutralShadowAmbientDarker: '--colorNeutralShadowAmbientDarker' as const,
  colorNeutralShadowKeyDarker: '--colorNeutralShadowKeyDarker' as const,
  colorBrandShadowAmbient: '--colorBrandShadowAmbient' as const,
  colorBrandShadowKey: '--colorBrandShadowKey' as const
};

export const FluentV9FontFamilyTokens = {
  fontFamilyBase: '--fontFamilyBase' as const,
  fontFamilyMonospace: '--fontFamilyMonospace' as const,
  fontFamilyNumeric: '--fontFamilyNumeric' as const
};
